<template>
  <div id="tab">
    <div class="tab__itemContainer" :style="tabDesign">
      <div class="tab__itemContent">
        <div
          v-for="(tabItem, i) in tabItems"
          :key="tabItem.text"
          @click="select(i)"
          class="tab__item"
          :style="tabItem.selected ? 'border-bottom: 3px solid ' + tabFontColor : ''"
        >
          {{ tabItem.text }}
        </div>
      </div>
    </div>
    <div
      class="tab__groupContainer"
      v-if="tabItems[1].selected && event.isGroupEvent"
    >
      <div class="tab__groupContent" ref="buttonContent">
        <div v-for="n in event.numberOfGroups" :key="n" class="tab__group">
          <button
            class="button__group"
            v-bind:ref="getGroupButtonId(n)"
            v-bind:class="{ selected__button: n === selectedButton }"
            @click="tapGroupButton(n)"
          >
            <span>{{ $t('eventGroupNumber', { n }) }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="tab__content">
      <div id="description" v-show="shouldShow(0)">
        <description
          :content="this.descriptionContent"
          :bgColor="this.descriptionBgColor"
          :bgImage="this.descriptionBgImage"
          :bgRepeat="this.descriptionBgRepeat"
        ></description>
      </div>
      <div id="result" :event="event" v-show="shouldShow(1)">
        <result
          :results="results"
          :event="event"
          :isEntried="isEntried"
          :myResult="myResult"
          :targetResult="targetResult"
          :numOfParticipants="numOfParticipants"
          @scrolledToBottom="scrolledToBottom()"
        ></result>
      </div>
    </div>
  </div>
</template>

<script>
import EventState from '@/entity/EventState'
import Description from './Description.vue'
import Result from './Result.vue'

export default {
  components: {
    Description,
    Result,
  },
  name: 'Tab',
  props: {
    results: Array,
    event: Object,
    groupId: Number,
    descriptionContent: String,
    descriptionBgColor: String,
    descriptionBgImage: String,
    descriptionBgRepeat: String,
    tabFontColor: String,
    tabId: String,
    isEntried: Boolean,
    myResult: Object,
    targetResult: Object,
    totalNumOfParticipants: Number,
    groupIdToNumOfParticipants: Object,
  },
  data: function () {
    return {
      tabItems: [
        {
          selected: true,
          text: this.$t('eventTabDescription'),
          content: '<description></description>',
        },
        {
          selected: false,
          text: '',
          content: '<result></result>',
        },
      ],
      next: 1,
      eventId: '1',
      selectedButton: 1,
    }
  },
  computed: {
    tabDesign() {
      return {
        '--font-color': this.tabFontColor,
        '--background-color': this.descriptionBgColor,
      }
    },
    numOfParticipants() {
      if (!this.event) {
        return 0
      }
      if (!this.event.isGroupEvent) {
        return this.totalNumOfParticipants
      }
      if (this.groupIdToNumOfParticipants && this.groupIdToNumOfParticipants[this.groupId] !== undefined) {
        return this.groupIdToNumOfParticipants[this.groupId]
      }
      return 0
    }
  },
  created() {
    this.updateTabs(this.event.eventType, this.event.status)
  },
  async mounted() {
    var tabIndex = 0
    if (this.tabId !== undefined) {
      switch (this.tabId) {
        case 'detail':
          tabIndex = 0
          break

        case 'result':
          tabIndex = 1
          break
      }
    } else {
      // イベント開催中以降のステータスは'result'表示
      if (this.event.status > 0) {
        tabIndex = 1
      }
    }
    this.select(Number(tabIndex))
    this.selectedButton = this.groupId + 1

    if (this.event.isGroupEvent) {
      // 描画後にDOM取得のため
      await this.$nextTick()
      this.scrollButtonArea(this.selectedButton)
    }
  },
  methods: {
    updateTabs: function (type, status) {
      switch (status) {
        case 0: // イベント開始前
          this.tabItems[1].text = this.$t('eventParticipantsWithCount', { countOfParticipants: this.totalNumOfParticipants })
          break
        case 1: // イベント実施中
        case 2: // イベント実施終了(結果集計中)
          this.tabItems[1].text = this.$t('eventTabScore')
          break
        case 3: // イベント終了(結果表示中)
        case 4: // イベント終了
          this.tabItems[1].text = this.$t('eventTabResult')
          break
        default:
          break
      }
    },
    select: function (index) {
      for (let i = 0; i < this.tabItems.length; i++) {
        if (i == index) {
          this.tabItems[i].selected = true
        } else {
          this.tabItems[i].selected = false
        }
      }
    },
    shouldShow: function (i) {
      return this.tabItems[i].selected
    },
    scrolledToBottom: function () {
      this.$emit('loadResult')
    },
    tapGroupButton: function (tapId) {
      this.selectedButton = tapId
      this.$parent.groupId = tapId - 1
      this.$parent.next = 1
      this.$emit('loadResult')
    },
    getGroupButtonId: function (n) {
      return 'button_' + n
    },
    scrollButtonArea: function (n) {
      const buttonRef = this.getGroupButtonId(n)
      const targetArea = this.$refs.buttonContent
      const targetButton = this.$refs[buttonRef]
      if (targetArea != undefined || targetButton != undefined) {
        const buttonRect = targetButton[0].getBoundingClientRect()
        let offset = 0
        if (n > 1) {
          offset = window.innerWidth * 0.1
        }
        const scrollWidth = buttonRect.left - offset
        targetArea.scrollLeft = scrollWidth
      }
    },
  },
}
</script>

<style scoped>
.tab__itemContainer {
  height: 42px;
  border-bottom: 1px solid #eeeeee;
  background-color: var(--background-color);
}
.tab__itemContent {
  max-width: 500px;
  margin: 0 auto;
}
.tab__item {
  line-height: 42px;
  display: inline-block;
  width: 50%;
  height: 42px;
  font-size: 14px;
  color: var(--font-color);
  text-align: center;
}
.tab__groupContainer {
  height: 56px;
  border-bottom: 1px solid #eeeeee;
}
.tab__groupContent {
  max-width: 500px;
  margin: 0 auto;
  overflow: scroll;
  white-space: nowrap;
}
.tab__groupContent::-webkit-scrollbar {
  display: none;
}
.tab__group {
  line-height: 56px;
  display: inline-block;
  width: 30%;
  height: 56px;
  font-size: 14px;
  color: #000;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
}
.button__group {
  width: 90%;
  height: 32px;
  font-style: normal;
  font-weight: bold;
  background-color: Transparent;
  border: 1px solid #808080;
  border-radius: 16px;
  text-align: center;
  color: #808080;
  font-size: 12px;
  line-height: 18px;
  box-shadow: none;
  outline: none;
}
.selected__button {
  width: 90%;
  height: 32px;
  font-style: normal;
  font-weight: bold;
  background-color: #188dff;
  border-style: solid;
  border-color: #188dff;
  border-radius: 16px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  box-shadow: none;
  outline: none;
}
</style>
